var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition-group',{attrs:{"name":"fade"}},_vm._l((_vm.modals),function(modal){return _c('hot-modal',{key:modal.id,attrs:{"modal":modal}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }